import { ReactNode } from 'react';
import { defineMessage } from 'react-intl';

import { NavigationBar, Page, PageContent, SmConstrainedPageBody } from '@ocx/ui';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';

type ReceiptLayoutProps = {
  children: ReactNode;
  modal?: boolean;
  safeAreaBottomOffsetEnabled?: boolean;
};

export const ReceiptLayout = ({ children, modal, safeAreaBottomOffsetEnabled }: ReceiptLayoutProps) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'receipt:htmlTitle',
          defaultMessage: 'Receipt',
          description: 'HTML title tag for Receipt Page',
        })}
      />
      <NavigationBar left={modal ? <BackButton /> : undefined} center={<VendorLogo />} />
      <PageContent bgcolor="background.paper" safeAreaBottomOffsetEnabled={safeAreaBottomOffsetEnabled}>
        <SmConstrainedPageBody variant="fill">{children}</SmConstrainedPageBody>
      </PageContent>
    </Page>
  );
};
